import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChild,
  Input,
  OnInit,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { Params } from '@angular/router';
import { v4 as uuid } from 'uuid';

@Component({
  selector: 's-ui-tab',
  templateUrl: './s-ui-tab.component.html',
  styleUrls: ['./s-ui-tab.component.css'],
  imports: [],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SUiTabComponent implements OnInit {
  @Input() key?: string;
  @Input() header?: string;
  @Input() index?: number | string;
  @Input() disabled?: boolean;
  @Input() leftIcon?: string;
  @Input() noInset?: boolean;
  /**
   * @deprecated Not implemented, implement if needed
   */
  @Input() selected?: boolean;
  @Input() routerLink?: string | string[];
  @Input() queryParams?: Params;

  @ContentChild('header', { read: TemplateRef }) headerTemplate?: TemplateRef<unknown>;
  @ContentChild('lazy', { read: TemplateRef }) lazyTemplate?: TemplateRef<unknown>; // Lazy loading template
  @ViewChild('content') contentTemplate?: TemplateRef<unknown>; // Content template
  public lazyAndRendered?: boolean; // Flag to check if the lazy template has been rendered

  constructor(private cd: ChangeDetectorRef) {
    this.index ??= uuid();
  }

  ngOnInit() {
    this.key ??= this.header ?? this.index?.toString();
  }

  setIndex(index: number) {
    if (this.key == this.index?.toString()) {
      this.key = index?.toString();
    }
    this.index = index;
  }
}
